import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'app-file-grid-view',
	templateUrl: './file-grid-view.component.html',
	styleUrls: ['./file-grid-view.component.scss']
})
export class FileGridViewComponent {
	@Input() fileData;
	@Input() allowedDimensions;
	@Input() isPopup;
	@Input() public indexNumber: number;
	@Output() output = new EventEmitter();
	showToolbar;

	constructor() {}

	deleteFile(fileName): boolean {
		this.output.emit({ method: 'delete', fileName: fileName });
		return false;
	}

	editFile(file) {
		this.output.emit({ method: 'edit', file: file });
	}

	isEditDisabled() {
		const isImage: boolean = this.fileData.fileType === `image`;
		if (isImage) {
			const isRequiredDimensions: boolean = this.allowedDimensions;
			const isDimensionsNotEqual: boolean =
				this.allowedDimensions !== `${this.fileData.dimensions[0]}x${this.fileData.dimensions[1]}`;
			return Boolean(this.isPopup && isImage && isRequiredDimensions && isDimensionsNotEqual);
		}
	}

	selectFile() {
		if (this.isEditDisabled()) {
			this.output.emit({ method: 'edit', file: this.fileData });
		} else {
			this.output.emit({ method: 'selected', fileName: this.fileData.oldPath });
		}
	}
}
